import { ISeoData } from '../types/seo';

export function getVillageListSeoText(isEmpty: boolean, seoData?: ISeoData) {
  const resultText = seoData && isEmpty && seoData.notFoundText;
  if (!resultText) {
    return null;
  }

  return resultText;
}
